export const isLegacyUserId = (id: string | number | undefined): boolean => /^\d+$/.test(String(id ?? ''));
